// Copy map for the 8 safe presentation keys the backend computes in
// enforcementService.js's presentationKeyForTransition and embeds directly
// in a battle_input moderation-block response as
// `enforcementPresentation.presentationKey` (battleResult.js). The backend
// decides WHAT happened (state-transition semantics); this file only owns
// HOW it reads. Never derive this mapping's key from anything except the
// server's own presentationKey — the frontend must not recompute
// enforcement stage from score/standing itself.
//
// Sourced directly from the moderation-block response body, not from a
// second standing refetch — this is what closes the original race (the
// error banner used to depend on winning a refetch against the very
// enforcement transaction it was reporting on, so an escalating violation
// could briefly show the account's pre-escalation status).
const VIEW_STANDING = { actionLabel: "View Account Standing", actionPath: "/account" };

export const ENFORCEMENT_PRESENTATION_COPY = {
  // The base moderation-block message + the existing "View Rules" action
  // (from err.policy.rulesPath) already cover these two — no addendum text
  // needed, and the spec is explicit that a corrective-stage block should
  // not mention account consequences yet.
  BLOCK_ONLY: null,
  CORRECTIVE: null,
  RESTRICTION_RISK_WARNING: {
    text: "Repeated violations may result in temporary restrictions on your account.",
    ...VIEW_STANDING,
  },
  RESTRICTED_STARTED: {
    text: "Because violations continued after previous warnings, some generation features on your account are now temporarily limited. Continued violations may result in temporary suspension.",
    ...VIEW_STANDING,
  },
  RESTRICTED_CORRECTIVE: {
    text: "Your account remains temporarily limited. Please use matchups and wording that follow our Rules.",
    ...VIEW_STANDING,
  },
  SUSPENSION_RISK_WARNING: {
    text: "Your account remains temporarily limited. Further violations may result in temporary suspension.",
    ...VIEW_STANDING,
  },
  SUSPENDED_STARTED: {
    text: "Because Rules violations continued after repeated warnings, generation on your account has been temporarily suspended.",
    ...VIEW_STANDING,
  },
  EXCEPTIONAL_CONTAINMENT: {
    text: "This request required immediate account containment under our Rules — generation is temporarily suspended.",
    ...VIEW_STANDING,
  },
};

export function getEnforcementAddendum(enforcementPresentation) {
  if (!enforcementPresentation) return null;
  return ENFORCEMENT_PRESENTATION_COPY[enforcementPresentation.presentationKey] ?? null;
}
